module.exports = __webpack_public_path__ + "reddit.png?eeab8e655173a9129aa0ce0e9669ba24";